import { del, post, get, put, getBodyOnly } from "./api_helper";
import * as url from "./url_helper";
//Register trial user
// const putRegisterTrialUser = (data) => put(url.POST_NEW_TRIAL_USER, data);
const putRegisterTrialUser = (data) => post(url.POST_NEW_TRIAL_USER, data);

// Get trial user
const getRegisterTrialUser = () => getBodyOnly(url.GET_NEW_TRIAL_USER);

// Update trial user
const updateRegisterTrialUser = (data) => put(url.UPDATE_NEW_TRIAL_USER, data);

const deleteRegisterTrialUser = (data) => del(url.DELETE_NEW_TRIAL_USER, data);

// Send trial user email.
const sendRegisterTrialUserEmail = (data) =>
  put(url.SEND_NEW_TRIAL_USER_EMAIL, data);

// Login
const postLogin = (data) => post(url.POST_LOGIN, data);

const addUser = (data) => post(url.ADD_COGNITO_USER, data);

// Forget Password
const postForgetPwd = (data) => put(url.POST_FORGET_PASSWORD, data);

const resetPasswordFrgt = (data) => {
  return put(url.POST_RESET_FORGOT_PASSWORD, data);
};

const getCognitoUser = () => getBodyOnly(url.GET_NEW_COGNITO_USER);

//Added for update/delete cognito user
// Update cognito user
const updateUser = (user) => {
  console.log("in updateUser API user = ", user);
  put(url.COGNITO_USER, user);
}

// Delete cognito user
const deleteUser = (userObj) => {
  console.log("in deleteUser API user = ", userObj);
  del(url.COGNITO_USER, { params: { username: userObj.username } });
}



export {
  putRegisterTrialUser,
  getRegisterTrialUser,
  sendRegisterTrialUserEmail,
  updateRegisterTrialUser,
  postLogin,
  deleteRegisterTrialUser,
  addUser,
  postForgetPwd,
  resetPasswordFrgt,
  getCognitoUser,
  updateUser,
  deleteUser,
};